export default __webpack_public_path__ + "2019 Azide-based high-energy metal-organic frameworks with enhanced thermal stability.pdf";